<template>
  <!-- 产品管理 -->
  <div class="drawerStyle">
    <div>
      <a-col :span="24">
        <div class="rightMo">
          <div class="filter-container" style="display: flex; align-items: center;">
            <b>产品状态：</b>
            <a-radio-group
              name="radioGroup"
              v-model="character.status"
              @change="(e) => radioGroupChange(e, 'status', 'productManage')"
              :default-value="''"
              style="margin-right: 20px;"
            >
              <a-radio :value="''">全部</a-radio>
              <a-radio :value="0">在售</a-radio>
              <a-radio :value="1">停售</a-radio>
            </a-radio-group>
            <b>基础分类：</b>
            <a-radio-group
              name="radioGroup"
              v-model="character.productCount"
              @change="(e) => radioGroupChange(e, 'productCount', 'productManage')"
              style="margin-right: 20px;"
            >
              <a-radio value>全部</a-radio>
              <a-radio
                v-for="item in basicClassification"
                :key="item.value"
                :value="item.label"
              >{{ item.value }}</a-radio>
            </a-radio-group>
          </div>
          <div class="filter-container" style="display: flex; align-items: center;">
            <b>产品名称：</b>
            <a-input
              placeholder="请输入产品名称"
              v-model="queryDataObj.productName"
              class="filter-item search-item"
              @pressEnter="queryClick"
              allow-clear
            />
            <a-button type="primary" class="filter-item filter-button" @click="queryClick">查询</a-button>
            <advancedSearch
              style="margin-left: 14px;"
              @advancedSearch="advancedSearch"
              @save="save"
            />
            <a-button class="filter-item filter-button" @click="resetTable">重置</a-button>
            <a-button
              v-if="!showCol"
              v-hasPermission="'product:add'"
              type="primary"
              icon="plus-circle"
              class="filter-item"
              @click="addClick"
              style="margin-left:40px;"
            >
              <span>快速添加{{this.$tree([], 'purchase/productManage/index')}}</span>
            </a-button>
          </div>
          <div>
            <a-button
              v-if="showCol"
              v-hasPermission="'product:add'"
              type="primary"
              icon="plus-circle"
              class="filter-item add-but"
              @click="addClick"
            >
              <span>添加{{this.$tree([], 'purchase/productManage/index')}}</span>
            </a-button>
            <a-button
              v-if="showCol"
              v-hasPermission="'product:export'"
              icon="download"
              class="filter-item add-but"
              @click="exportClick"
              style="margin-left: 6px;background-color: rgb(250, 173, 20); color: white"
            >导出{{this.$tree([], 'purchase/productManage/index')}}</a-button>
          </div>
          <div :class="contentdivClass">
            <a-table
              :columns="!showCol ? filterColumnss : filterColumn"
              :components="componentesd"
              :data-source="tableData"
              :loading="tableLoadding"
              :pagination="pagination"
              :rowKey="(record,index)=>{return index}"
              @change="pageChange"
              :size="tableSize"
              :scroll="{ x: 1650, y: 404 }"
              bordered
            >
              <span v-if="!showCol" slot="filterDropdown">
                <a-card>
                  <a-checkbox-group
                    style="display:grid"
                    v-model="columnList"
                    :options="checkColumns"
                    :defaultValue="checkColumns"
                    @change="checkChange"
                  />
                  <a-tag
                    color="green"
                    @click="getColumns('productManages')"
                    style="position: absolute; right: 5px; bottom: 5px"
                  >确认</a-tag>
                </a-card>
              </span>
              <span v-if="showCol" slot="filterDropdown">
                <a-card>
                  <a-checkbox-group
                    style="display:grid"
                    v-model="columnList"
                    :options="checkColumn"
                    :defaultValue="checkColumn"
                    @change="checkChange"
                  />
                  <a-tag
                    color="green"
                    @click="getColumns('productManage')"
                    style="position: absolute; right: 5px; bottom: 5px"
                  >确认</a-tag>
                </a-card>
              </span>
              <template slot="productName" slot-scope="text, record">
                <a-tooltip placement="topLeft">
                  <template slot="title">{{record.productName}}</template>
                  <span @click="titleClick(record.id)" class="onClickStyle">{{ record.productName }}</span>
                </a-tooltip>
              </template>
              <template slot="fileIds" slot-scope="text, record">
                <a-icon
                  type="paper-clip"
                  v-if="record.fileIds && record.fileIds !== null && record.fileIds !==''"
                  :style="'color:' + storageColor"
                />
              </template>
              <!-- <template slot="productName" slot-scope="text, record">
                <span @click="productNameClick(record)" class="onClickStyle">{{ record.productName }}</span>
              </template>-->
              <template slot="productType" slot-scope="text, record">
                <span>{{ proTypeObj[record.productType] }}</span>
              </template>
              <template slot="price" slot-scope="text, record">
                <span
                  v-if="record.price"
                >¥ {{ parseFloat(record.price).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
              </template>
              <template slot="productCost" slot-scope="text, record">
                <span v-hasPermission="'product:money'">
                  <span
                    v-if="record.productCost"
                  >¥ {{ parseFloat(record.productCost).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
                </span>
              </template>
              <template slot="productCount" slot-scope="text, record">
                <div
                  @click="checkStockData({ productId: record.id, StockCount: 1})"
                  style="cursor: pointer; color: #096dd9;"
                >{{ record.productCount }}</div>
              </template>
              <template slot="addCol" slot-scope="text, record">
                <div @click="addRowClick(record)" style="color: #096dd9;cursor: pointer;">
                  <a-icon type="zoom-in" />加入
                </div>
              </template>
              <template slot="status" slot-scope="text, record">
                <a-tag v-if="record.status === 0" color="green">在售</a-tag>
                <a-tag v-if="record.status === 1" color="orange">停售</a-tag>
              </template>
              <template slot="operation" slot-scope="text, record">
                <!-- <span v-hasPermission="'log:view'">
                  <a-tooltip>
                    <template slot="title">查看日志</template>
                    <a-icon
                      type="eye"
                      theme="twoTone"
                      style="font-size: 16px;"
                      twoToneColor="#52c41a"
                      @click="logClick(record,'product')"
                    />
                  </a-tooltip>
                </span>
                <a-divider type="vertical" />-->
                <span v-if="record.creator === nowUserName">
                  <a-tooltip>
                    <template slot="title">修改</template>
                    <a-icon
                      type="edit"
                      theme="twoTone"
                      style="font-size: 16px;"
                      twoToneColor="#1890ff"
                      @click="editClick(record)"
                    />
                  </a-tooltip>
                  <a-divider type="vertical" />
                  <a-popconfirm
                    v-if="tableData.length"
                    title="确定删除这条数据吗?"
                    @confirm="() => onDelete(record.id)"
                  >
                    <a-tooltip>
                      <template slot="title">删除</template>
                      <a-icon
                        type="delete"
                        style="font-size: 16px; cursor: pointer;"
                        theme="twoTone"
                        twoToneColor="red"
                      />
                    </a-tooltip>
                  </a-popconfirm>
                </span>
                <span v-else>
                  <span v-hasPermission="'product:update'">
                    <a-tooltip>
                      <template slot="title">修改</template>
                      <a-icon
                        type="edit"
                        theme="twoTone"
                        style="font-size: 16px;"
                        twoToneColor="#1890ff"
                        @click="editClick(record)"
                      />
                    </a-tooltip>
                  </span>
                  <span v-hasPermission="'product:delete'">
                    <a-divider type="vertical" />
                    <a-popconfirm
                      v-if="tableData.length"
                      title="确定删除这条数据吗?"
                      @confirm="() => onDelete(record.id)"
                    >
                      <a-tooltip>
                        <template slot="title">删除</template>
                        <a-icon
                          type="delete"
                          style="font-size: 16px; cursor: pointer;"
                          theme="twoTone"
                          twoToneColor="red"
                        />
                      </a-tooltip>
                    </a-popconfirm>
                  </span>
                </span>
              </template>
              <template #footer v-if="totalsFoot">
                <totals
                  :columnv="filterColumnv"
                  :footerDataSource="footerDataSource"
                  :scrolls="scrolls"
                />
              </template>
            </a-table>
          </div>
        </div>
      </a-col>
    </div>
    <a-modal
      :dialog-style="{ top: '10%' }"
      :title="this.$tree([], 'inventory/productList/index')"
      :visible="productVsible"
      :destroyOnClose="true"
      :maskClosable="true"
      width="65%"
      :footer="null"
      @ok="cancel"
      @cancel="cancel"
    >
      <a-table
        :columns="productColumns"
        :data-source="tableDatas"
        :loading="tableLoaddings"
        :pagination="paginations"
        size="middle"
        :scroll="{ y: 460, x: 1000 }"
        :rowKey="(record,index)=>{return record.id}"
        @change="pageChanges"
        bordered
      >
        <template slot="productName" slot-scope="text, record">
          <a-tooltip>
            <template slot="title">{{ record.productName}}</template>
            <!-- @click="titleClick(record)" class="onClickStyle" -->
            <span>{{ record.productName}}</span>
          </a-tooltip>
        </template>
        <template slot="payDate" slot-scope="text, record">
          <span>{{dateFormat(record.payDate)}}</span>
        </template>
      </a-table>
    </a-modal>
    <add-edit-vue
      ref="addEditRef"
      :title="addTitle"
      :dialog-visible="addVisible"
      :pro-type-list="proTypeList"
      :isPurApply="isShow"
      @success="addSuccess"
      @close="addClose"
    />
    <copy-drawer
      ref="publicDrawerRef"
      :title="publicDrawer.title"
      :dialog-visible="publicDrawer.visible"
      :component-name="publicDrawer.comName"
      @close="publicDrawerClose"
      @editClick="titleClick"
    />
  </div>
</template>

<script>
import addEditVue from './addEdit.vue'
import totals from '../../common/totals.vue'
import { total } from '../../../utils/totals'
import advancedSearch from '@/components/advancedSearch/index.vue'
import { mixin } from '@/mixin/index.js'
import { getQuery } from '@/mixin/getQuery.js'
// import copyDrawer from '@/components/drawer/copyDrawer.vue'

export default {
  name: 'productIndex',
  mixins: [getQuery, mixin],
  components: { addEditVue, totals, advancedSearch, copyDrawer: () => import('@/components/drawer/copyDrawer.vue') },
  props: {
    typed: {
      type: Boolean,
      default: true
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    typed: {
      handler (newVal, oldVal) {
        if (newVal) this.contentdivClass = 'contentdiv'
        else this.contentdivClass = 'contentdivs'
      },
      immediate: true
    },
    isShow: {
      handler (newVal, oldVal) {
        if (newVal) {
          this.columnss = [
            {
              title: '操作',
              dataIndex: 'addCol',
              width: 70,
              onFilterDropdownVisibleChange: (e) => this.onFilterDropdownVisibleChange(e, 'productManages'),
              scopedSlots: { customRender: 'addCol', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon' }
            },
            {
              title: 'ID',
              dataIndex: 'id',
              // sorter: (a, b) => a.id - b.id,
              width: 60,
              align: 'center',
              ellipsis: true
            },
            {
              title: '附',
              dataIndex: 'fileIds',
              width: 50,
              ellipsis: true,
              align: 'center',
              scopedSlots: { customRender: 'fileIds' }
            },
            {
              title: '产品名称',
              dataIndex: 'productName',
              width: 150,
              align: 'center',
              ellipsis: true
              // scopedSlots: { customRender: 'productName' }
            },
            {
              title: '型号',
              dataIndex: 'type',
              align: 'center',
              ellipsis: true,
              width: 200
            },
            {
              title: '规格',
              align: 'center',
              dataIndex: 'specification',
              ellipsis: true,
              width: 200
            },
            {
              title: '产品类别',
              dataIndex: 'productType',
              align: 'center',
              ellipsis: true,
              width: 150,
              scopedSlots: { customRender: 'productType' }
            },
            // {
            //   title: '库存量',
            //   dataIndex: 'productCount',
            //   scopedSlots: { customRender: 'productCount' },
            //   align: 'center',
            //   ellipsis: true,
            //   width: 100
            // },
            {
              width: 100,
              title: '基本单位',
              align: 'center',
              dataIndex: 'unit'
            },
            {
              title: '零售价(元)',
              dataIndex: 'price',
              ellipsis: true,
              align: 'center',
              width: 120,
              scopedSlots: { customRender: 'price' }
            },
            // {
            //   title: '成本价格(元)',
            //   dataIndex: 'productCost',
            //   align: 'center',
            //   width: 120,
            //   scopedSlots: { customRender: 'productCost' }
            // },
            {
              title: '状态',
              dataIndex: 'status',
              align: 'center',
              width: 90,
              scopedSlots: { customRender: 'status' }
            },
            {
              width: 100,
              title: '创建人',
              align: 'center',
              dataIndex: 'creator'
            }
          ]
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      basicClassification: [
        // {
        //   value: '低于库存下限',
        //   label: 0
        // },
        // {
        //   value: '高于库存上限',
        //   label: 1
        // },
        {
          value: '库存为0',
          label: 0
        },
        {
          value: '库存不为0',
          label: 1
        }
      ],
      publicDrawer: {
        title: '',
        visible: false,
        comName: ''
      },
      dataForm: {},
      nowUserName: this.$db.get('USER').username,
      storageColor: this.$db.get('COLOR')[0],
      character: {
        productCount: ''
      },
      scrolls: { x: 1650 },
      footerDataSource: [
        {
          id: '本页',
          price: 0,
          productCost: 0,
          operation: '-'
        },
        {
          id: '总计',
          price: 0,
          productCost: 0,
          operation: '-'
        }
      ],
      rowList: [],
      contentdivClass: 'contentdiv',
      totalsFoot: true,
      rowArr: [],
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          // sorter: (a, b) => a.id - b.id,
          width: 60,
          align: 'center',
          ellipsis: true
        },
        {
          title: '附',
          dataIndex: 'fileIds',
          width: 50,
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'fileIds' }
        },
        {
          title: '产品名称',
          dataIndex: 'productName',
          width: 150,
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'productName' }
        },
        {
          title: '型号',
          dataIndex: 'type',
          align: 'center',
          ellipsis: true,
          width: 200
        },
        {
          title: '规格',
          align: 'center',
          dataIndex: 'specification',
          ellipsis: true,
          width: 200
        },
        {
          title: '产品类别',
          dataIndex: 'productType',
          align: 'center',
          ellipsis: true,
          width: 150,
          scopedSlots: { customRender: 'productType' }
        },
        {
          width: 100,
          title: '基本单位',
          align: 'center',
          dataIndex: 'unit'
        },
        {
          title: '零售价(元)',
          dataIndex: 'price',
          ellipsis: true,
          // align: 'center',
          width: 150,
          scopedSlots: { customRender: 'price' }
        },
        {
          title: '成本价格(元)',
          dataIndex: 'productCost',
          ellipsis: true,
          // align: 'center',
          width: 150,
          scopedSlots: { customRender: 'productCost' }
        },
        {
          title: '状态',
          dataIndex: 'status',
          align: 'center',
          width: 90,
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '库存量',
          dataIndex: 'productCount',
          align: 'center',
          ellipsis: true,
          width: 100
        },
        {
          // width: 100,
          title: '创建人',
          align: 'center',
          dataIndex: 'creator'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          align: 'center',
          fixed: 'right',
          width: 150,
          onFilterDropdownVisibleChange: (e) => this.onFilterDropdownVisibleChange(e, 'productManage'),
          scopedSlots: { customRender: 'operation', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon' }
        }
      ],
      columnss: [
        {
          title: '操作',
          dataIndex: 'addCol',
          width: 70,
          onFilterDropdownVisibleChange: (e) => this.onFilterDropdownVisibleChange(e, 'productManages'),
          scopedSlots: { customRender: 'addCol', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon' }
        },
        {
          title: 'ID',
          dataIndex: 'id',
          // sorter: (a, b) => a.id - b.id,
          width: 60,
          align: 'center',
          ellipsis: true
        },
        {
          title: '附',
          dataIndex: 'fileIds',
          width: 50,
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'fileIds' }
        },
        {
          title: '产品名称',
          dataIndex: 'productName',
          width: 150,
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'productName' }
        },
        {
          title: '型号',
          dataIndex: 'type',
          align: 'center',
          ellipsis: true,
          width: 200
        },
        {
          title: '规格',
          align: 'center',
          dataIndex: 'specification',
          ellipsis: true,
          width: 200
        },
        {
          title: '产品类别',
          dataIndex: 'productType',
          align: 'center',
          ellipsis: true,
          width: 150,
          scopedSlots: { customRender: 'productType' }
        },
        {
          title: '库存量',
          dataIndex: 'productCount',
          scopedSlots: { customRender: 'productCount' },
          align: 'center',
          ellipsis: true,
          width: 100
        },
        {
          width: 100,
          title: '基本单位',
          align: 'center',
          dataIndex: 'unit'
        },
        {
          title: '零售价(元)',
          dataIndex: 'price',
          // align: 'center',
          ellipsis: true,
          width: 150,
          scopedSlots: { customRender: 'price' }
        },
        {
          title: '成本价格(元)',
          dataIndex: 'productCost',
          ellipsis: true,
          // align: 'center',
          width: 150,
          scopedSlots: { customRender: 'productCost' }
        },
        {
          title: '状态',
          dataIndex: 'status',
          align: 'center',
          width: 90,
          scopedSlots: { customRender: 'status' }
        },
        {
          width: 100,
          title: '创建人',
          align: 'center',
          dataIndex: 'creator'
        }
      ],
      columnv: [
        {
          title: 'ID',
          dataIndex: 'id',
          align: 'center',
          width: 58,
          ellipsis: true,
          customCell: () => {
            return {
              style: {
                fontWeight: 900
              }
            }
          }
        },
        {
          title: '附',
          dataIndex: 'fileIds',
          width: 50,
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'fileIds' }
        },
        {
          title: '产品名称',
          dataIndex: 'productName',
          width: 150,
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'productName' }
        },
        {
          title: '型号',
          dataIndex: 'type',
          align: 'center',
          width: 200
        },
        {
          title: '规格',
          dataIndex: 'specification',
          ellipsis: true,
          width: 200
        },
        {
          title: '产品类别',
          dataIndex: 'productType',
          ellipsis: true,
          width: 150,
          scopedSlots: { customRender: 'productType' }
        },
        {
          title: '基本单位',
          width: 100,
          dataIndex: 'unit'
        },
        {
          title: '零售价(元)',
          dataIndex: 'price',
          width: 150,
          // align: 'center',
          ellipsis: true,
          customCell: () => {
            return {
              style: {
                fontWeight: 900
              }
            }
          },
          scopedSlots: { customRender: 'price' }
        },
        {
          title: '成本价格(元)',
          dataIndex: 'productCost',
          width: 150,
          // align: 'center',
          ellipsis: true,
          customCell: () => {
            return {
              style: {
                fontWeight: 900
              }
            }
          },
          scopedSlots: { customRender: 'productCost' }
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: 90,
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '库存量',
          dataIndex: 'productCount',
          align: 'center',
          ellipsis: true,
          width: 100
        },
        {
          // width: 100,
          title: '创建人',
          align: 'center',
          dataIndex: 'creator'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          fixed: 'right',
          width: 150,
          scopedSlots: { customRender: 'operation' }
        }
      ],
      tableData: [],
      addVisible: false,
      addTitle: '',
      pagination: {
        pageSize: 10,
        pageNum: 1,
        current: 1,
        total: 0,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true, // 是否可以快速跳转至某页
        showSizeChanger: true // 是否可以改变pageSize
      },
      tableLoadding: false,
      tableSize: 'middle',
      showCol: true,
      proTypeList: [],
      proTypeObj: {},
      productTypeData: [],
      advancedEnquiries: [
        {
          type: 'numberInput',
          label: '零售价',
          layout: 24,
          key: ['priceStart', 'priceEnd'],
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'numberInput',
          label: '成本价格',
          layout: 24,
          key: ['productCostStart', 'productCostEnd'],
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'input',
          label: '产品名称',
          key: 'productName',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'input',
          label: '产品型号',
          key: 'type',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'input',
          label: '产品规格',
          key: 'specification',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'input',
          label: '产品单位',
          key: 'unit',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'time',
          label: '创建起始日期',
          key: 'createTimeStart',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'time',
          label: '创建结束日期',
          key: 'createTimeEnd',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'radio',
          label: '状态',
          layout: 24,
          key: 'status',
          content: [
            { label: '全部', value: '' },
            { label: '在售', value: 0 },
            { label: '停售', value: 1 }
          ],
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'select',
          label: '产品类别',
          key: 'productType',
          content: [],
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'input',
          label: '创建人',
          key: 'creator',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'radio',
          label: '分类',
          defaultModel: true,
          modelKey: 'queryDataObj',
          keyLabel: ['label', 'value'],
          key: 'status',
          content: [
            {
              label: '全部',
              value: ''
            },
            {
              label: '库存为0',
              value: 0
            },
            {
              label: '库存不为0',
              value: 1
            }
          ]
        }
      ],
      productVsible: false,
      tableLoaddings: false,
      paginations: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true, // 是否可以快速跳转至某页
        showSizeChanger: true // 是否可以改变pageSize
      },
      tableDatas: [],
      productParams: {},
      productColumns: [
        {
          title: 'ID',
          dataIndex: 'id',
          width: 60,
          align: 'center',
          ellipsis: true
        },
        {
          title: '产品名称',
          dataIndex: 'productName',
          width: 300,
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'productName' }
        },
        {
          title: '产品型号',
          dataIndex: 'productType',
          width: 100,
          align: 'center',
          ellipsis: true
        },
        {
          title: '产品规格',
          dataIndex: 'productSpecification',
          width: 100,
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'productSpecification' }
        },
        {
          title: '所在仓库',
          dataIndex: 'stockName',
          align: 'center',
          ellipsis: true,
          width: 180,
          scopedSlots: { customRender: 'stockName' }
        },
        {
          title: '库存量',
          dataIndex: 'stockCount',
          align: 'center',
          ellipsis: true,
          width: 180
        },
        {
          title: '产品单位',
          dataIndex: 'productUnit',
          align: 'center',
          ellipsis: true
        }
      ]
    }
  },
  provide () {
    return {
      advancedEnquiries: this
    }
  },
  created () {
    if (!this.showCol) {
      this.geTableColumn('productManages')
    } else {
      this.geTableColumn('productManage')
    }
  },
  mounted () {
    if (this.$store.state.queryCriteria.queryList.productManage) {
      this.character = this.queryDataObj = this.$store.state.queryCriteria.queryList.productManage
    }
    this.initData(this.character)
    this.initDectData()
    this.totals()
  },
  beforeMount () {
    // this.statistics()
  },
  methods: {
    // 查看库存产品信息
    checkStockData (params) {
      // this.$router.push({ path: '/inventory/productList', query: { productName: name } })
      this.productParams = params
      this.productVsible = true
      this.getstockData()
    },
    getstockData (params = {}) {
      this.tableLoaddings = true
      params.pageNum = this.paginations.current
      params.pageSize = this.paginations.pageSize
      params = { ...params, ...this.productParams }
      this.$get('/stockProduct/list', { ...params }).then(res => {
        if (res.status === 200 && res.data.status === 1) {
          let data = res.data
          this.paginations.total = Number(data.data.total)
          this.tableDatas = data.data.rows
        } else {
          this.$message.error(res.data.message)
        }
      }).finally(r => {
        setTimeout(() => {
          this.tableLoaddings = false
        }, 500)
      })
    },
    cancel () {
      this.productVsible = false
    },
    pageChanges (pageVal) {
      this.paginations.current = pageVal.current
      this.paginations.pageNum = pageVal.current
      this.paginations.pageSize = pageVal.pageSize
      this.getstockData()
    },
    // 点击标题跳转到详情页
    titleClick (id) {
      this.$get('/product/getById', { id: id }).then(res => {
        let resData = res.data
        if (resData.status === 1) {
          // 展开抽屉
          this.publicDrawer.title = this.$tree([], 'purchase/productManage/index')
          this.publicDrawer.visible = true
          this.publicDrawer.comName = 'purchase/productManage/details.vue'
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(resData.data, null, [resData.data.creator])
          })
        } else {
          this.$message.warning(resData.message)
        }
      })
    },
    publicDrawerClose () { // 公共抽屉关闭
      this.initData(this.character)
      this.publicDrawer = {
        title: '',
        visible: false,
        comName: ''
      }
    },
    statistics () {
      this.$getListStatistics('product', { ...this.character }, res => {
        let moenyNumber = res
        this.$set(this.footerDataSource, 1, {
          id: '总计',
          price: '￥' + parseFloat(moenyNumber.price).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          productCost: '￥' + parseFloat(moenyNumber.productCost).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          operation: '-'
        })
      })
    },
    // 重置
    resetAdvancedSearch () {
      this.pagination.current = 1
      this.pagination.pageNum = 1
      this.pagination.pageSize = 10
    },
    // 保存并查询
    advancedSearch () {
      this.resetAdvancedSearch()
      this.character = { ...this.character, ...this.dataForm, ...this.queryDataObj }
      this.setQueryList({ productManage: this.character })
      this.initData(this.character)
      this.statistics()
    },
    // 直接查询不保存
    save () {
      this.resetAdvancedSearch()
      let character = { ...this.character, ...this.dataForm }
      this.initData(character)
      this.dataForm = {}
    },
    addShowType () {
      // console.log('22222222222')

      this.typed = false
    },
    initDectData () {
      this.$get('/common/dict/getListByEn', { dictTypeEn: 'product_type' }).then(res => {
        if (res.data.status === 1) {
          let resData = res.data.data
          this.checkStatusList = []
          resData.forEach(item => {
            this.proTypeList.push({
              label: item.dictName,
              value: item.dictCode
            })
          })
          resData.forEach(item => {
            this.proTypeObj[item.dictCode] = item.dictName
            this.productTypeData.push({
              label: item.dictName,
              value: item.dictCode
            })
            this.advancedEnquiries[9].content.push({
              label: item.dictName,
              value: item.dictCode
            })
          })
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    addShowCol (dataSource) { // 当页面作为添加页面时,不显示某些列
      this.showCol = false
      this.totalsFoot = false
      this.tableSize = 'small'
      // 采购申请进入
      console.log(this.isShow, 'this.isShow')
      // if (this.isShow) {
      //   this.columnss = [
      //     {
      //       title: '操作',
      //       dataIndex: 'addCol',
      //       width: 70,
      //       onFilterDropdownVisibleChange: (e) => this.onFilterDropdownVisibleChange(e, 'productManages'),
      //       scopedSlots: { customRender: 'addCol', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon' }
      //     },
      //     {
      //       title: 'ID',
      //       dataIndex: 'id',
      //       // sorter: (a, b) => a.id - b.id,
      //       width: 60,
      //       align: 'center',
      //       ellipsis: true
      //     },
      //     {
      //       title: '附',
      //       dataIndex: 'fileIds',
      //       width: 50,
      //       ellipsis: true,
      //       align: 'center',
      //       scopedSlots: { customRender: 'fileIds' }
      //     },
      //     {
      //       title: '产品名称',
      //       dataIndex: 'productName',
      //       width: 150,
      //       align: 'center',
      //       ellipsis: true,
      //       scopedSlots: { customRender: 'productName' }
      //     },
      //     {
      //       title: '型号',
      //       dataIndex: 'type',
      //       align: 'center',
      //       ellipsis: true,
      //       width: 200
      //     },
      //     {
      //       title: '规格',
      //       align: 'center',
      //       dataIndex: 'specification',
      //       ellipsis: true,
      //       width: 200
      //     },
      //     {
      //       title: '产品类别',
      //       dataIndex: 'productType',
      //       align: 'center',
      //       ellipsis: true,
      //       width: 150,
      //       scopedSlots: { customRender: 'productType' }
      //     },
      //     {
      //       width: 100,
      //       title: '基本单位',
      //       align: 'center',
      //       dataIndex: 'unit'
      //     },
      //     {
      //       title: '零售价(元)',
      //       dataIndex: 'price',
      //       align: 'center',
      //       width: 120,
      //       scopedSlots: { customRender: 'price' }
      //     },
      //     // {
      //     //   title: '成本价格(元)',
      //     //   dataIndex: 'productCost',
      //     //   align: 'center',
      //     //   width: 120,
      //     //   scopedSlots: { customRender: 'productCost' }
      //     // },
      //     {
      //       title: '状态',
      //       dataIndex: 'status',
      //       align: 'center',
      //       width: 90,
      //       scopedSlots: { customRender: 'status' }
      //     },
      //     {
      //       width: 100,
      //       title: '创建人',
      //       align: 'center',
      //       dataIndex: 'creator'
      //     }
      //   ]
      // }
      // 添加第一列
      // this.columns.unshift({
      //   title: '操作',
      //   dataIndex: 'addCol',
      //   width: 70,
      //   onFilterDropdownVisibleChange: (e) => this.onFilterDropdownVisibleChange(e, 'productManage'),
      //   scopedSlots: { customRender: 'addCol', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon' }
      // })
      // this.columnv.unshift({
      //   title: '操作',
      //   dataIndex: 'addCol',
      //   width: 70,
      //   scopedSlots: { customRender: 'addCol' }
      // })
      // console.log('dataSource =>', dataSource)
      if (dataSource && dataSource.length > 0) {
        // console.log('dataSource =>', dataSource)
        dataSource.forEach(item => {
          this.$set(item, 'id', item.productId)
        })
        this.rowArr = [...dataSource]
      }
      // 删除最后一列
      // this.columns.pop()
      // this.columnv.pop()
      //
      this.checkChange(this.columnList)
    },
    pageChange (pageVal) {
      // 分页查询
      this.pagination.pageNum = pageVal.current
      this.pagination.pageSize = pageVal.pageSize
      this.pagination.current = pageVal.current
      this.initData(this.character)
    },
    initData (params = {}) {
      this.tableLoadding = true
      if (this.character.productName) params.productName = this.character.productName
      if (this.character.status >= 0) {
        params.status = this.character.status
      }
      params.pageSize = this.pagination.pageSize
      params.pageNum = this.pagination.pageNum
      this.statistics()
      this.$get('/product/list', params).then(res => {
        if (res.data.status === 1) {
          this.tableData = res.data.data.rows
          let arr = []
          let arr2 = []
          for (let item of this.tableData) {
            arr.push(item.price)
            arr2.push(item.productCost)
          }
          this.footerDataSource[0].price = total(arr)[0]
          this.footerDataSource[0].productCost = total(arr2)[0]
          this.pagination.total = Number(res.data.data.total)
          setTimeout(() => {
            this.tableLoadding = false
          }, 500)
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    queryClick () {
      this.pagination.current = 1
      this.pagination.pageNum = 1
      let character = { ...this.character, ...this.queryDataObj }
      this.character = Object.assign({}, this.character, this.queryDataObj)
      this.initData({ ...character })
      this.setQueryList({ productManage: character })
      this.statistics()
    },
    resetTable () {
      this.character = {
        productCount: ''
      }
      this.dataForm = {}
      this.pagination.current = 1
      this.pagination.pageNum = 1
      this.pagination.pageSize = 10
      this.queryDataObj = {}
      let character = { ...this.character, ...this.queryDataObj }
      this.setQueryList({ productManage: character })
      this.initData()
      this.statistics()
    },
    totals () {
      let dom = this.$el.querySelectorAll('.ant-table-body')[0]
      dom.addEventListener('scroll', () => {
        this.$el.querySelectorAll('.ant-table-body')[1].scrollLeft = dom.scrollLeft
      })
    },
    // productNameClick (rowVal) {
    //   this.publicDrawer.title = '产品详情'
    //   this.publicDrawer.visible = true
    //   this.publicDrawer.comName = 'purchase/productManage/show.vue'
    //   this.$nextTick(() => {
    //     this.$refs.publicDrawerRef.setForm(rowVal)
    //   })
    // },
    // publicDrawerClose () {
    //   this.publicDrawer = {
    //     title: '',
    //     visible: false,
    //     comName: ''
    //   }
    // },
    delRow (id) {
      // console.log('id =>', id)
      // console.log('this.rowArr =>', this.rowArr)
      this.rowArr = this.rowArr.filter(item => item.id !== id)
    },
    addRowClick (rowVal) {
      if (this.rowArr.length < 1) {
        this.rowArr.push(rowVal)
        const rowData = {
          productId: rowVal.id,
          productName: rowVal.productName,
          productType: rowVal.type,
          productUnit: rowVal.unit,
          productCount: 1, // 数量
          productRemark: '',
          // productCost: rowVal.price, // 采购价格
          productCost: rowVal.productCost, // 采购价格
          productPrice: rowVal.price,
          productTotalCost: 1 * Number(rowVal.productCost),
          productSpecification: rowVal.specification
        }
        this.$emit('succ', rowData)
      } else {
        console.log('eeeeeeeeee', this.rowArr.some(item => item.id === rowVal.id))
        if (this.rowArr.some(item => item.id === rowVal.id)) {
          this.$message.warning('该产品已加入过！')
        } else {
          this.rowArr.push(rowVal)
          const rowData = {
            productId: rowVal.id,
            productName: rowVal.productName,
            productType: rowVal.type,
            productUnit: rowVal.unit,
            productCount: 1, // 数量
            productRemark: '',
            // productCost: rowVal.price, // 采购价格
            productCost: rowVal.productCost, // 采购价格
            productPrice: rowVal.price,
            productTotalCost: 1 * Number(rowVal.productCost),
            productSpecification: rowVal.specification
          }
          this.$emit('succ', rowData)
        }
      }
    },
    exportClick () {
      this.$download('/product/export', { ...this.character, pageSize: -1, pageNum: -1 }, `${new Date().getTime()}${this.$tree([], 'purchase/productManage/index')}.xlsx`)
    },
    addClick () {
      if (this.isShow) {
        // this.$refs.addEditRef.setPrice()
      }
      this.addTitle = `[新建]-${this.$tree([], 'purchase/productManage/index')}`
      this.addVisible = true
    },
    addSuccess () {
      this.addVisible = false
      // this.pagination.current = 1
      // this.pagination.pageNum = 1
      this.initData(this.character)
    },
    addClose () {
      this.addVisible = false
    },
    editClick (rowValue) {
      this.addTitle = `[修改]${this.$tree([], 'purchase/productManage/index')}`
      this.addVisible = true
      this.$refs.addEditRef.setForm(rowValue)
    },
    onDelete (rowId) {
      const deleteArr = [rowId]
      console.log('删除', deleteArr)
      this.$get(`/product/delByIds`, { ids: deleteArr }).then(res => {
        if (res.data.status === 1) {
          this.$message.success(res.data.message)
          this.initData()
        } else {
          this.$message.warning(res.data.message)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-table.ant-table-bordered .ant-table-footer {
  padding: 0px;
}
/deep/ .ant-table-small > .ant-table-content > .ant-table-body {
  margin: 0px -1px;
}
/deep/ .ant-table-footer .ant-table-body {
  overflow: hidden !important;
}

.borderStyle {
  border: 1px solid #e6ebf5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}
.leftMo {
  padding: 10px;
}

.rightMo {
}
.contentdiv {
  padding: 4px 0px;
  width: 83vw;
  /deep/ ::-webkit-scrollbar {
    width: 0.8rem !important;
  }
}
.contentdivs {
  padding: 4px 0px;
  width: 63vw;
  /deep/ ::-webkit-scrollbar {
    width: 0.8rem !important;
  }
}
.add-div {
  text-align: right;
}
.filter-container {
  padding: 4px;
  margin: 10px;
  background-color: #fff;
}
.filter-row {
  margin-bottom: 14px;
}
.filter-button {
  margin-left: 20px;
}
.filter-item {
  display: inline-block;
  vertical-align: middle;
}
.search-item {
  margin-right: 14px;
  width: 200px;
}
.add-but {
  margin-top: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/purchase/productManage/index.vue